import { VehicleRepository } from '@/core/vehicle/domain/VehicleRepository.ts'
import { VehiclesClient } from 'online-customer-services-ts'
import { Vehicle } from '@/core/vehicle/domain/Vehicle.ts'

export class VehicleRepositoryBackendClient implements VehicleRepository {
  private readonly vehicleClient: VehiclesClient

  constructor(url: string) {
    this.vehicleClient = new VehiclesClient(url)
  }

  async getVehicleByPlate(plate: string): Promise<Vehicle | null> {
    try {
      const vehicle = await this.vehicleClient.getVehicleByPlate3(plate)
      return {
        vin: vehicle.vin?.trim() ?? '',
        plate: vehicle.plateNumber?.trim() ?? '',
        brandCode: vehicle.brandCode?.trim() ?? '',
        brand: vehicle.brand?.trim() ?? '',
        model: vehicle.model?.trim() ?? '',
        kilometers: vehicle.kilometers ?? 0
      }
    } catch {
      return null
    }
  }
}
